const getLicensingRestrictions = (licensingInfos) => Object.values(licensingInfos).reduce((acc, licensingInfo) => licensingInfo.reduce((acc, licensingRepInfo) => {
    acc[licensingRepInfo.rep_id] ??= {
        rep_id: licensingRepInfo.rep_id,
        rep_full_name: licensingRepInfo.rep_full_name,
        has_access_to_work: licensingRepInfo.has_access_to_work,
        states: [],
        counties: [],
        municipalities: [],
    };
    acc[licensingRepInfo.rep_id].states.push({
        name: licensingRepInfo.state_name,
        id: licensingRepInfo.state_id,
        is_license_needed: licensingRepInfo.is_state_license_required,
        has_license: licensingRepInfo.has_state_license,
    });
    acc[licensingRepInfo.rep_id].counties.push({
        name: licensingRepInfo.county_name,
        id: licensingRepInfo.county_id,
        is_license_needed: licensingRepInfo.is_county_license_required,
        has_license: licensingRepInfo.has_county_license,
    });
    acc[licensingRepInfo.rep_id].municipalities.push({
        name: licensingRepInfo.municipality_name,
        id: licensingRepInfo.municipality_id,
        is_license_needed: licensingRepInfo.is_municipality_license_required,
        has_license: licensingRepInfo.has_municipality_license,
    });
    return acc;
}, acc), {});
export default getLicensingRestrictions;
